import React from 'react'
import {Link, Box} from '@miro-site/core'
import styled from 'styled-components'
import theme from './theme'

export type Link = {
  title: string
  path: string
}

interface Links {
  links: Link[]
}

const FooterLinksContainer = styled(Box).attrs({
  $styles: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: ['center', 'center', undefined],
    flex: ['0 0 100%', '0 0 100%', null],
  },
  $mt: [20, 20, null],
})``

const Copyright = styled(Box).attrs({
  $styles: {
    fontSize: theme.footer.links.bottom.fontSize,
    lineHeight: theme.footer.links.bottom.lineHeight,
    color: theme.colors.primaryWhite,
  },
  $mr: theme.footer.copyright.margin.right,
})``

const CopyrightLink = styled(Link)`
  ${props => props.theme.normalizeStyles(theme.footer.links.bottom)}
`

const FooterLink = styled(Link).attrs({
  $mr: theme.footer.copyrightLink.margin.right,
})`
  ${props => props.theme.normalizeStyles(theme.footer.links.bottom)}

  &:last-child {
    margin-right: 0;
  }
`

const FooterLinks = (props: Links): React.ReactElement => {
  const {links} = props
  const year = new Date().getFullYear()

  return (
    <FooterLinksContainer>
      <Copyright>
        &copy; {year}{' '}
        <CopyrightLink href="https://miro.com/" $color="white" $size="medium">
          Miro
        </CopyrightLink>
      </Copyright>

      {links.map((link, index) => {
        return (
          <FooterLink key={index} href={link.path} $color="white">
            {link.title}
          </FooterLink>
        )
      })}
    </FooterLinksContainer>
  )
}

export default FooterLinks
